
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');


const DeleteAction = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();
        props.context.componentParent.deleteRowHandler(props.data);
    };

    return (
        <div>
			<button onClick={handleClick} className="custom-btn label label-success"><i className="icofont icofont-save"></i> Delete </button>
       
        </div>
    );
};

export default DeleteAction;
